import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import WBackArrow from '../../../assets/svg/backArrow';
import { useSelector } from 'react-redux';
import { getCMSData } from '../../../redux/actions/authAction';

const TITLE = "Clefill - Cart"

const WCartclear = ({ history }) => {

    const cmsData = useSelector(state => state.auth.cmsDetail?.['emptycart'])
    const dispatch = useDispatch();
    //Fetching data from api
    useEffect(() => {
        const abortController = new AbortController()

        //Product type list
        dispatch(getCMSData({ cmsKey: ["emptycart"] }))
            .then(res => { })
            .catch(err => console.log("error"))

        return () => {
            abortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    return (
        <>
            <Helmet>
                <title>{TITLE}</title>
                <meta name="keywords" content={cmsData?.metakeyword} />
                <meta name="description" content={cmsData?.metadescription} />
            </Helmet>

            
            <div className="empty-cart-message">
                <div className="main-text">Keep your home clean </div>
                <div className="sub-text">not your cart!</div>
            </div>
        </>
    );
}

export default WCartclear;